import { Outlet } from "react-router-dom";
import Header from "../Componets/layout_components/header";
import Footer from "../Componets/layout_components/footer";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const MainLayout = () => {
    const theme = useTheme();
    return (
        <>
            <Box sx={{ background: theme.palette.user.bgColor}} >
                <Header />
                <Outlet />
                <Footer />
            </Box>
        </>
    )
}

export default MainLayout